module.exports = __webpack_public_path__ + "static/media/selfie.ff434cbd.jpg";